
const BACKEND_SERVER_URL = 'https://server.ltiora.com';
// const BACKEND_SERVER_URL = 'http://192.168.0.13:3000';

const maxCardList = {
    visitorParking: 2,
    announcements: 5,
    serviceRequests: 3,
    bookings: 3,
    violations: 4
}

const ManagementMenuItems = [
    'Dashboard', 
    'Announcements',
    'Bookings',
    'Service Requests',
    'Violations',
    'Visitor Parking',
    // 'Packages',
    'To Dos',
    'Unit File',
    // 'Reports',
    'Events',
    'Library', 
    // 'Classifieds',
    // 'Discussion Forum',
    // 'Training Library',
    'My Account'
];
const OwnerMenuItems = [
    'Dashboard',
    'Announcements',
    'Bookings',
    'Service Requests',
    'Violations',
    'Visitor Parking',
    'Events',
    'Library',
    'My Account'
];

const carBrands = ['Toyota', 'Honda', 'Ford', 'BMW', 'Audi'];
const carModels: { [key: string]: string[] } = {
  Toyota: ['Camry', 'Corolla', 'RAV4'],
  Honda: ['Civic', 'Accord', 'CR-V'],
  Ford: ['F-150', 'Mustang', 'Explorer'],
  BMW: ['320i', 'X5', 'M3'],
  Audi: ['A4', 'Q5', 'A6'],
};

const userDashboardMaxLimits = {
    visitorParking: 2,
    announcements: 8,
    serviceRequests: 6,
    bookings: 4,
    violations: 8
};

const FIXED_PAGE_ROWS = 10;

export {
    maxCardList,
    userDashboardMaxLimits,
    ManagementMenuItems,
    OwnerMenuItems,
    BACKEND_SERVER_URL,
    FIXED_PAGE_ROWS,
    carBrands,
    carModels
}

